import React, { useEffect } from 'react'
import styled from 'styled-components'
import Tracking from '../../../utils/helpers/Tracking'

const Container = styled.div`
  .c-wrap {
    max-width: 1280px;
    margin: auto;
    padding: 0 24px;
  }

  .c-lay {
    display: table;
    width: 100%;
  }

  .c-lay-main {
    display: table-cell;
    vertical-align: top;
    text-align: left;
  }

  li {
    font-size: 14px;
  }

  .c-lay-main .main-title,
  .c-lay-main h2 {
    font-family: 'Source Sans Pro', Trebuchet MS, Arial, Helvetica, sans-serif;
  }

  .c-lay-main .main-title {
    display: block;
    padding: 60px 0 12px 0;
    margin: 0 0 40px 0;
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
    color: #262626;
  }

  .main-title {
    display: inline;
    font-size: 22px;
    text-align: center;
  }

  .c-lay-main .main-title:after {
    display: block;
    content: '';
    margin: 12px auto 0 auto;
    height: 1px;
    width: 70px;
    background-color: #262626;
  }

  .c-lay-main h2 {
    padding: 16px 0 6px 0;
    font-size: 14px;
    color: #494949;
  }

  .c-lay-main p {
    font-size: 14px;
    color: #494949;
    text-align: justify;
  }

  .c-lay-main p:last-child {
    padding-bottom: 60px;
  }

  .c-lay-main p.c-plist {
    padding-left: 14px;
  }

  .c-lay-main p.u-center {
    text-align: center;
  }

  .c-lay-main p,
  .c-lay-main li {
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }

  .border-breadcrumb {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 2px solid #e0e0e3;
  }

  .c-breadcrumb {
    max-width: 1280px;
    padding: 3px 24px;
    list-style-type: none;
    text-align: left;
    border-top: none;
  }

  .c-breadcrumb a {
    text-decoration: none;
    color: #db0237;
  }

  .c-breadcrumb span {
    display: inline-block;
    font-weight: 400;
    padding-left: 15px;
    font-size: 12px;
    line-height: 30px;
  }

  .c-breadcrumb span:first-child:before {
    content: '';
    padding-right: 0;
  }

  .c-breadcrumb span:before {
    content: '>';
    position: relative;
    top: 2px;
    color: #e0e0e3;
    padding-right: 15px;
    font-weight: 800;
    font-size: 16px;
  }
`
const CGU = () => {
  useEffect(() => {
    Tracking.PushView({ pagename: 'gtu' })
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
    if (window.location.hash && isChrome) {
      setTimeout(() => {
        const urlhash = window.location.hash
        window.location.hash = ''
        window.location.hash = urlhash
      }, 300)
    }
  }, [])

  return (
    <Container>
      <div className="c-main">
        <div className="c-slice">
          <div className="c-wrap">
            <div className="c-breadcrumb">
              <span>
                <a href="/">SeLoger.com</a>
              </span>
              <span>Informations&nbsp;L&eacute;gales</span>
            </div>
            <div className="c-lay">
              <div className="c-lay-main">
                <h1 className="u-center main-title">CONDITIONS G&Eacute;N&Eacute;RALES D&apos;UTILISATION</h1>
                <h2>1. PREAMBULE</h2>
                <h2>
                  <strong>1.1 OBJET DES CONDITIONS G&Eacute;N&Eacute;RALES D&apos;UTILISATION</strong>
                </h2>
                <p>
                  Les pr&eacute;sentes Conditions g&eacute;n&eacute;rales d&apos;utilisation (ci-apr&egrave;s d&eacute;sign&eacute;e par <em>&laquo; les CGU &raquo;</em>) ont pour
                  objet de d&eacute;finir les conditions d&apos;utilisation du site Internet accessible notamment &agrave; l&apos;adresse www.seloger.com (ci-apr&egrave;s
                  d&eacute;sign&eacute; par <em>&laquo;le Site Internet &raquo;</em>) ainsi que de l&apos;application associ&eacute;e (ci-apr&egrave;s d&eacute;sign&eacute;e par{' '}
                  <em>&laquo; l&apos;Application &raquo;</em>) que la soci&eacute;t&eacute; DIGITAL CLASSIFIEDS FRANCE, Groupe SeLoger (ci-apr&egrave;s d&eacute;sign&eacute;e par{' '}
                  <em>&laquo; la Soci&eacute;t&eacute; &raquo;</em>) met &agrave; disposition des internautes (ci-apr&egrave;s d&eacute;sign&eacute;s par les{' '}
                  <em>&laquo; Utilisateurs &raquo;</em>).
                </p>
                <p>
                  <strong>1.2 IDENTIFICATION DE L&apos;&Eacute;DITEUR</strong>
                </p>
                <p>L&apos;Utilisateur est inform&eacute; que le Site Internet est &eacute;dit&eacute; par la Soci&eacute;t&eacute; :</p>
                <p>
                  <strong>DIGITAL CLASSIFIEDS FRANCE (Groupe SeLoger)</strong>
                </p>
                <p>Soci&eacute;t&eacute; par Actions Simplifi&eacute;e au capital de 715 526 149 &euro;</p>
                <p>Si&egrave;ge social : 65, rue Ordener 75018 Paris</p>
                <p>RCS Paris 789 177 391</p>
                <p>TVA intra-communautaire : FR 297 891 77 391</p>
                <p>représentée par la société de droit allemand AVIV GROUP GMBH, elle-même représentée par Monsieur Ait Voncke, en qualité de gérant.</p>
                <p>
                  <strong>1.3 DIRECTEUR DE LA PUBLICATION</strong>
                </p>
                <p>Le directeur de la publication du Site Internet est Monsieur Ait Voncke.</p>
                <p>
                  <strong>1.4 CONTACTER LA SOCI&Eacute;T&Eacute;</strong>
                </p>
                <p>L&apos;Utilisateur a la possibilit&eacute; de prendre contact aupr&egrave;s de la Soci&eacute;t&eacute; :</p>
                <ul>
                  <li>par lettre simple &agrave; l&apos;adresse indiqu&eacute;e &agrave; l&apos;article 1.2 ci-dessus ;</li>
                  <li>
                    par courrier &eacute;lectronique en utilisant le <a href="http://www.seloger.com/contact.html">formulaire de contact</a> ;
                  </li>
                  <li>
                    par t&eacute;l&eacute;phone au 01 53 38 80 00 du <strong>lundi au vendredi de 8h &agrave; 19h et le samedi de 10h &agrave; 15h</strong> (appel non
                    surtax&eacute;).
                  </li>
                </ul>
                <p>
                  <strong>1.5 H&Eacute;BERGEUR DU SITE INTERNET</strong>
                </p>
                <p>Amazon Web Services EMEA SARL, Succursale Fran&ccedil;aise</p>
                <p>31 Place des Corolles</p>
                <p>92400 COURBEVOIE</p>
                <p>01.46.17.10.00</p>
                <h2>2. D&Eacute;FINITIONS</h2>
                <p>Pour les besoins des pr&eacute;sentes CGU, les termes en majuscules ont la signification suivante :</p>
                <p>
                  &laquo; <strong>Application</strong> &raquo; : d&eacute;signe le service &eacute;lectronique interactif exploit&eacute; par la Soci&eacute;t&eacute;, accessible
                  depuis tout terminal disposant d&apos;une connexion au r&eacute;seau Internet, par t&eacute;l&eacute;chargement gratuit sur l&apos;AppStore ou GooglePlay ou par
                  consultation via un navigateur web et qui permet, le cas &eacute;ch&eacute;ant apr&egrave;s installation, d&apos;acc&eacute;der aux Services.
                </p>
                <p>
                  &laquo; <strong>Donn&eacute;es</strong> &raquo; : d&eacute;signent les donn&eacute;es &agrave; caract&egrave;re personnel telles que d&eacute;finies &agrave;
                  l&apos;article 4 du R&egrave;glement (UE) 2016/679 du Parlement europ&eacute;en et du Conseil du 27 avril 2016 relatif &agrave; la protection des personnes
                  physiques &agrave; l&apos;&eacute;gard du traitement des donn&eacute;es &agrave; caract&egrave;re personnel et &agrave; la libre circulation de ces donn&eacute;es
                  (ci-apr&egrave;s d&eacute;sign&eacute; &laquo; <strong>R&egrave;glement G&eacute;n&eacute;ral sur la Protection des Donn&eacute;es</strong> &raquo;) qui sont
                  fournies par l&apos;Utilisateur &agrave; la Soci&eacute;t&eacute; ou qui sont recueillies par la Soci&eacute;t&eacute; &agrave; l&apos;occasion de
                  l&apos;utilisation du Site Internet, de l&apos;Application et/ou des Services. 2.2
                </p>
                <p>
                  &laquo; <strong>Annonceurs</strong> &raquo; : d&eacute;signent les Annonceurs ayant souscrit avec la Soci&eacute;t&eacute; un contrat de diffusion d&apos;annonces
                  de location et/ou de vente de biens immobiliers sur le Site Internet et/ou l&apos;Application.
                </p>
                <p>
                  La diffusion d&apos;annonces sur le Site et/ou l&apos;Application est r&eacute;serv&eacute;e aux Annonceurs entrant dans une des cat&eacute;gories suivantes :
                </p>
                <p>
                  - les professionnels de l&apos;immobilier d&eacute;tenant une carte de transaction ou de gestion conform&eacute;ment &agrave; la loi Hoguet n&deg; 70-9 du 2
                  janvier 1970 ;
                </p>
                <p>- les notaires ;</p>
                <p>- les avocats exer&ccedil;ant &agrave; titre accessoire l&apos;activit&eacute; de mandataire en transactions immobili&egrave;res ;</p>
                <p>- les huissiers ;</p>
                <p>- les promoteurs immobiliers ;</p>
                <p>- les constructeurs.</p>

                <p>
                  Le Site / l&rsquo;Application permet &eacute;galement de consulter des annonces de location de biens d&apos;habitation propos&eacute;es par des particuliers. Ces
                  annonces sont identifi&eacute;es sur le Site Internet et/ou l&apos;Application en tant qu&apos; &laquo; annonces de particuliers &raquo;.
                </p>

                <p>
                  &laquo; <strong>Site Internet</strong> &raquo; : d&eacute;signe le service &eacute;lectronique interactif &eacute;dit&eacute; et exploit&eacute; par la
                  Soci&eacute;t&eacute;, accessible notamment &agrave; l&apos;adresse www.seloger.com, depuis lequel elle permet l&apos;acc&egrave;s &agrave; ses Services.
                </p>
                <p>
                  &laquo; <strong>Serveur</strong> &raquo; (en anglais : &laquo; Server &raquo; ) : d&eacute;signe un ordinateur h&eacute;bergeant un service applicatif et
                  poss&eacute;dant une grande quantit&eacute; d&apos;espace disque o&ugrave; sont stock&eacute;s des fichiers.
                </p>
                <p>
                  &laquo; <strong>Serveur du Site Internet</strong> &raquo; : d&eacute;signe les serveurs d&apos;h&eacute;bergement du Site Internet sur lequel sont
                  install&eacute;s et fournis les Services mis &agrave; disposition de l&apos;Utilisateur par la Soci&eacute;t&eacute;.
                </p>
                <p>
                  &laquo; <strong>Services</strong> &raquo; : d&eacute;signent les services fournis par la Soci&eacute;t&eacute; sur le Site Internet et/ou l&apos;Application et
                  d&eacute;crits &agrave; l&apos;article 4 des pr&eacute;sentes CGU, ainsi que leurs extensions sous forme d&apos;alerte, de newsletters, d&apos;agenda et de
                  fonctionnalit&eacute;s du terminal de l&apos;Utilisateur, n&eacute;cessaires &agrave; leur fonctionnement.
                </p>
                <p>
                  &laquo; <strong>Utilisateur</strong> &raquo; : d&eacute;signe toute personne physique qui acc&egrave;de au Site Internet et/ou &agrave; l&apos;Application dans le
                  cadre d&apos;un usage strictement priv&eacute;.
                </p>
                <h2>3. CHAMP D&apos;APPLICATION, ACCEPTATION ET MODIFICATION DES CGU</h2>
                <p>
                  <strong>3.1.</strong> Les pr&eacute;sentes CGU ont pour objet de d&eacute;finir les conditions dans lesquelles l&apos;Utilisateur b&eacute;n&eacute;ficie des
                  Services fournis par la Soci&eacute;t&eacute; au travers de son Site Internet et/ou de son Application.
                </p>
                <p>
                  L&apos;ensemble des Services fournis par la Soci&eacute;t&eacute; et mis &agrave; disposition de l&apos;Utilisateur est d&eacute;taill&eacute; sur le Site
                  Internet et/ou sur l&apos;Application.
                </p>
                <p>
                  <strong>3.2.</strong> La souscription, l&apos;acc&egrave;s ou l&apos;utilisation des Services implique l&apos;acceptation sans restrictions ni r&eacute;serves des
                  pr&eacute;sentes CGU par l&apos;Utilisateur.
                </p>
                <p>
                  <strong>3.3.</strong> Les pr&eacute;sentes CGU pouvant faire l&apos;objet de modifications, les conditions applicables sont celles en vigueur et accessibles sur
                  le Site Internet et/ou sur l&apos;Application de la Soci&eacute;t&eacute; &agrave; la date d&apos;acc&egrave;s au Site Internet et/ou &agrave; l&apos;Application
                  par l&apos;Utilisateur.
                </p>
                <p>
                  <strong>3.4.</strong> Si l&apos;Application a &eacute;t&eacute; t&eacute;l&eacute;charg&eacute;e depuis l&apos;App Store d&apos;Apple ou le Google Play Store,
                  l&apos;Utilisateur a &eacute;t&eacute;, en outre, invit&eacute; en amont, &agrave; accepter les termes des conditions g&eacute;n&eacute;rales propres &agrave; ces
                  deux plateformes et s&apos;engage &agrave; respecter ces derni&egrave;res.
                </p>
                <h2>4. ACCES ET DISPONIBILITE DES SERVICES</h2>
                <p>
                  <strong>4.1. DESCRIPTION DES SERVICES</strong>
                </p>
                <p>
                  Les Services fournis sur le Site Internet et/ou l&apos;Application de la Soci&eacute;t&eacute; consistent &agrave; faciliter les d&eacute;marches de
                  l&apos;Utilisateur dans sa recherche d&apos;achat et/ou de vente et/ou de location d&apos;un bien immobilier en lui permettant notamment de
                  b&eacute;n&eacute;ficier gratuitement des Services suivants :
                </p>
                <ul>
                  <li>
                    la possibilit&eacute; de se constituer un compte personnel au travers duquel l&apos;Utilisateur aura notamment la possibilit&eacute; d&apos;acc&eacute;der aux
                    offres de vente / location de biens immobiliers correspondant &agrave; des crit&egrave;res de recherches particuliers qu&apos;il aura s&eacute;lectionn&eacute;s
                    au pr&eacute;alable. Ce service permet &eacute;galement de recevoir par courrier &eacute;lectronique les nouvelles offres de vente / location de biens
                    immobiliers correspondant aux crit&egrave;res s&eacute;lectionn&eacute;s par l&apos;Utilisateur.
                    <br />
                    En cr&eacute;ant un compte personnel, l&apos;Utilisateur dispose d&apos;un identifiant unique et d&apos;un mot de passe strictement personnels, qu&apos;il
                    s&apos;engage &agrave; conserver confidentiels et &agrave; ne pas transmettre &agrave; des tiers.
                    <br />
                    L&apos;Utilisateur est seul autoris&eacute; &agrave; acc&eacute;der et utiliser les Services &agrave; l&apos;aide de son identifiant unique et de son mot de
                    passe.
                    <br />
                    Tout acc&egrave;s au compte personnel de l&apos;Utilisateur avec son identifiant unique et son mot de passe est r&eacute;put&eacute; de plein droit avoir
                    &eacute;t&eacute; effectu&eacute; par l&apos;Utilisateur.
                    <br />
                    De m&ecirc;me que l&apos;acc&egrave;s aux Services avec ces identifiant et mot de passe s&apos;effectue sous la seule responsabilit&eacute; de
                    l&apos;Utilisateur.
                    <br />
                    D&egrave;s lors, en cas de perte, de vol ou tout acte frauduleux &agrave; l&apos;&eacute;gard de son identifiant unique et de son mot de passe,
                    l&apos;Utilisateur doit en informer la Soci&eacute;t&eacute; dans les plus brefs d&eacute;lais et justifier &agrave; cette occasion de son identit&eacute; par
                    tous moyens.
                    <br />A r&eacute;ception de sa notification d&ucirc;ment justifi&eacute;e, la Soci&eacute;t&eacute; adressera &agrave; l&apos;Utilisateur un nouvel identifiant
                    et mot de passe, &agrave; charge pour lui de les conserver strictement confidentiels.
                  </li>
                  <li>un service de recherche, visualisation d&apos;offres de vente et / location de biens immobiliers ;</li>
                  <li>
                    l&apos;acc&egrave;s aux coordonn&eacute;es des Annonceurs titulaires des offres de vente / location de biens immobiliers diffus&eacute;s sur le Site Internet
                    et/ou l&apos;Application ;
                  </li>
                  <li>un service de mise en relation avec des Annonceurs ;</li>
                  <li>
                    un service permettant &agrave; l&apos;Utilisateur de rechercher, via le Site Internet et/ou l&apos;Application, des solutions de cr&eacute;dit immobilier et de
                    prendre contact aupr&egrave;s de diff&eacute;rents &eacute;tablissements de cr&eacute;dit ou courtiers partenaires de la Soci&eacute;t&eacute; ;
                  </li>
                  <li>
                    un service de simulations destin&eacute;s &agrave; permettre &agrave; l&apos;Utilisateur d&apos;effectuer des calculs particuliers et d&apos;obtenir une
                    estimation approximative des valeurs calcul&eacute;es ;
                  </li>
                  <li>un service d&apos;abonnement gratuit &agrave; une lettre d&apos;information personnalis&eacute;e ;</li>
                  <li>un service d&apos;acc&egrave;s &agrave; des conseils pratiques destin&eacute;s &agrave; accompagner l&apos;Utilisateur dans son projet immobilier ;</li>
                  <li>un service de consultation des prix de l&apos;immobilier.</li>
                  <li>
                    la possibilité pour l’Utilisateur, en recherche d&apos;un bien en location, de constituer un dossier de location déclaratif (ci-après “le Dossier de Location”)
                    et d&apos;en donner accès à un Annonceur diffusant son annonce en tant que particulier.
                    <ul>
                      <li>
                        L&rsquo;Utilisateur pourra acc&eacute;der au formulaire de d&eacute;p&ocirc;t de son Dossier de Location depuis son compte personnel ou directement depuis
                        le d&eacute;tail d&apos;une annonce de location de particulier.
                      </li>
                      <li>
                        Pour constituer son Dossier de Location, l&rsquo;Utilisateur doit obligatoirement avoir cr&eacute;&eacute; un compte personnel et y &ecirc;tre
                        connect&eacute;.
                      </li>
                      <li>
                        L&rsquo;Utilisateur doit saisir les informations suivantes :
                        <ul>
                          <li>ses coordonn&eacute;es personnelles : nom et pr&eacute;nom, num&eacute;ro de t&eacute;l&eacute;phone et adresse email</li>
                          <li>
                            des informations sur la situation personnelle et professionnelle du (ou des) (co)locataire(s) et du (ou des) garant(s), ainsi que leurs revenus
                            d&eacute;claratifs &nbsp;
                          </li>
                          <li>un texte de pr&eacute;sentation et l&apos;objet de sa recherche.</li>
                        </ul>
                      </li>
                      <li>
                        Les &eacute;l&eacute;ments ainsi communiqu&eacute;s par l&rsquo;Utilisateur, sous sa seule et enti&egrave;re responsabilit&eacute;, constituent des
                        donn&eacute;es purement d&eacute;claratives ne faisant l&rsquo;objet d&rsquo;aucune v&eacute;rification par la Soci&eacute;t&eacute;. A ce titre, la
                        Soci&eacute;t&eacute; ne joue aucun r&ocirc;le actif de nature &agrave; lui confier une connaissance ou un contr&ocirc;le des donn&eacute;es composant le
                        Dossier de Location. La Soci&eacute;t&eacute; ne peut en cons&eacute;quence &ecirc;tre tenue responsable de la compl&eacute;tude, de la fiabilit&eacute; et
                        de la v&eacute;racit&eacute; des donn&eacute;es communiqu&eacute;es par l&rsquo;Utilisateur en vue de la constitution de son Dossier de Location.
                      </li>
                      <li>
                        L&rsquo;Utilisateur pourra &agrave; tout moment compl&eacute;ter, modifier ou supprimer son Dossier de Location &agrave; partir de son compte personnel.
                      </li>
                      <li>
                        Les donn&eacute;es transmises par l&rsquo;Utilisateur ont uniquement pour objet de permettre &agrave; l&rsquo;Utilisateur de constituer son Dossier de
                        Location.
                      </li>
                      <li>La constitution du Dossier de Location et sa transmission &agrave; l&rsquo;Annonceur sont gratuites pour l&rsquo;Utilisateur.</li>
                      <li>
                        L&rsquo;Utilisateur aura la facult&eacute;, en cochant la case pr&eacute;vue &agrave; cet effet, de donner son accord expr&egrave;s &agrave; la transmission
                        de son Dossier de Location &agrave; l&rsquo;Annonceur diffusant l&rsquo;annonce &agrave; laquelle souhaite postuler l&rsquo;Utilisateur. L&rsquo;Annonceur
                        pourra ensuite, depuis son compte personnel, acc&eacute;der au Dossier de Location de l&rsquo;Utilisateur.
                      </li>
                      <li>
                        L&rsquo;Annonceur sera seul responsable de l&rsquo;utilisation du Dossier de Location et reste libre de consulter ou non le dossier de qui lui aura
                        &eacute;t&eacute; transmis et de contacter ou non l&rsquo;Utilisateur, la Soci&eacute;t&eacute; n&rsquo;intervenant en aucun cas dans la s&eacute;lection
                        des candidats &agrave; la location ni, de mani&egrave;re g&eacute;n&eacute;rale, dans les relations entre l&rsquo;Annonceur et l&rsquo;Utilisateur. &nbsp;
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  Les Services sont d&eacute;crits plus avant sur le Site Internet et/ou l&apos;Application. L&apos;Utilisateur est inform&eacute; que lesdits Services sont
                  susceptibles d&apos;&eacute;volution constante.
                </p>
                <p>
                  L&apos;Utilisateur est inform&eacute; et reconna&icirc;t que l&apos;activit&eacute; de la Soci&eacute;t&eacute; se limite &agrave; faciliter la mise en relation
                  des Utilisateurs avec les Annonceurs et / ou &eacute;tablissements de cr&eacute;dit ou courtiers partenaires de la Soci&eacute;t&eacute;. Sa responsabilit&eacute;
                  ne saurait en aucune mani&egrave;re &ecirc;tre engag&eacute;e dans le cadre des relations, accords et discussions susceptibles d&apos;intervenir entre les
                  Utilisateurs et les Annonceurs et / ou les &eacute;tablissements de cr&eacute;dit ou courtiers partenaires de la Soci&eacute;t&eacute;.
                </p>
                <p>
                  <strong>4.2. ACC&Egrave;S AUX SERVICES</strong>
                </p>
                <p>Les Services sont librement et exclusivement accessibles en ligne sur le Site Internet et/ou sur l&apos;Application de la Soci&eacute;t&eacute;.</p>
                <p>
                  <strong>4.3. DISPONIBILIT&Eacute; DES SERVICES</strong>
                </p>
                <p>
                  La Soci&eacute;t&eacute; fait ses meilleurs efforts afin de rendre ses Services disponibles 24 heures sur 24 et 7 jours sur 7, ind&eacute;pendamment des
                  op&eacute;rations de maintenance desdits Services et/ou Serveurs et/ou du Site Internet et/ou de l&apos;Application. A ce titre, la Soci&eacute;t&eacute; est
                  tenue d&apos;une obligation de moyens.
                </p>
                <p>
                  La Soci&eacute;t&eacute; se r&eacute;serve la possibilit&eacute; de modifier, interrompre, &agrave; tout moment, temporairement ou de mani&egrave;re permanente
                  tout ou partie des Services sans information pr&eacute;alable des Utilisateurs et sans droit &agrave; indemnit&eacute;s.
                </p>
                <p>
                  La Soci&eacute;t&eacute; fait ses meilleurs efforts pour assurer la continuit&eacute; des Services ; cependant, compte tenu de la complexit&eacute; et des
                  circonstances sp&eacute;cifiques &agrave; l&apos;activit&eacute; particuli&egrave;re d&apos;h&eacute;bergeur, la Soci&eacute;t&eacute; ne peut &ecirc;tre tenue
                  qu&apos;&agrave; une obligation de moyens au titre des pr&eacute;sentes CGU.
                </p>
                <p>
                  En cons&eacute;quence la Soci&eacute;t&eacute; ne saurait &ecirc;tre tenue responsable des difficult&eacute;s ou impossibilit&eacute;s d&apos;acc&egrave;s, de la
                  lenteur de la connexion ou tout autre probl&egrave;me technique dus &agrave; des circonstances et/ou &agrave; des interm&eacute;diaires techniques
                  ext&eacute;rieurs &agrave; la Soci&eacute;t&eacute;.
                </p>
                <h2>5. GARANTIES &ndash; RESPONSABILITE &ndash; FORCE MAJEURE</h2>
                <p>
                  <strong>5.1 GARANTIE DE L&apos;UTILISATEUR</strong>
                </p>
                <p>
                  En acc&eacute;dant au Site Internet et/ou &agrave; l&apos;Application de la Soci&eacute;t&eacute;, l&apos;Utilisateur d&eacute;clare, garantit et s&apos;engage
                  &agrave; :
                </p>
                <ul>
                  <li>
                    acc&eacute;der et utiliser le Site Internet et/ou l&apos;Application et les Services en toute bonne foi, de mani&egrave;re raisonnable, non contraire aux termes
                    des pr&eacute;sentes CGU et pour une utilisation strictement personnelle et &agrave; des fins non lucratives ;
                  </li>
                  <li>
                    ne pas utiliser de dispositifs ou logiciels autres que ceux fournis par la Soci&eacute;t&eacute; destin&eacute;s &agrave; i) affecter ou tenter d&apos;affecter
                    le bon fonctionnement du Site Internet et/ou de l&apos;Application et/ou des Services qu&apos;il contient ii) ou encore d&apos;extraire, modifier, consulter,
                    m&ecirc;me en m&eacute;moire tampon ou temporaire, ou encore pour une utilisation individualis&eacute;e, tout ou partie du Site Internet et/ou de
                    l&apos;Application ;
                  </li>
                  <li>
                    ne pas acc&eacute;der et/ou utiliser le Site Internet et/ou l&apos;Application et/ou les Services fournis par la Soci&eacute;t&eacute; sur ledit Site Internet
                    ou Application &agrave; des fins illicites et/ou dans le but de causer un pr&eacute;judice &agrave; la r&eacute;putation et l&apos;image de la
                    Soci&eacute;t&eacute; ou plus g&eacute;n&eacute;ralement &agrave; porter atteinte aux droits, notamment de propri&eacute;t&eacute; intellectuelle, de la
                    Soci&eacute;t&eacute; et/ou de tiers ;
                  </li>
                  <li>
                    ne pas commercialiser directement ou indirectement les Services et/ou l&apos;acc&egrave;s aux Services et/ou l&apos;acc&egrave;s au Site Internet et/ou &agrave;
                    l&apos;Application ;
                  </li>
                  <li>
                    ne pas r&eacute;utiliser tout ou partie du Site Internet et/ou de l&apos;Application et des Services qu&apos;il contient, en particulier &agrave; des fins
                    commerciales et/ou collectives et/ou &agrave; des fins personnelles sous une forme et/ou un m&eacute;dia non autoris&eacute; par la Soci&eacute;t&eacute; ;
                  </li>
                  <li>
                    ne pas exploiter les Services fournis par la Soci&eacute;t&eacute; ou les donn&eacute;es auxquelles il pourrait avoir acc&egrave;s via lesdits Services et/ou le
                    Site internet et/ou l&apos;Application &agrave; des fins directement ou indirectement commerciales et/ou &agrave; des fins personnelles sous une forme et/ou un
                    m&eacute;dia non autoris&eacute;(s) par la Soci&eacute;t&eacute; ;
                  </li>
                  <li>
                    ne pas reproduire, repr&eacute;senter tout ou partie du Site Internet et/ou de l&apos;Application &agrave; des fins priv&eacute;es au-del&agrave; des exceptions
                    l&eacute;gales pr&eacute;vues, en particulier par le Code de la propri&eacute;t&eacute; intellectuelle, ou en vue d&apos;une commercialisation directe ou
                    indirecte notamment aupr&egrave;s de tiers ;
                  </li>
                  <li>ne pas limiter l&apos;acc&egrave;s et l&apos;utilisation au Site Internet et/ou &agrave; l&apos;Application et/ou des Services ;</li>
                  <li>
                    ne modifier, y compris en m&eacute;moire tampon ou temporaire, aucune mention ou &eacute;l&eacute;ment des Services et/ou du contenu du Site Internet et/ou de
                    l&apos;Application ;
                  </li>
                  <li>
                    ne pas contrevenir aux dispositions des articles 323-1 &agrave; 323-7 du Code P&eacute;nal r&eacute;primant les pratiques dites de &laquo; hacking &raquo; ;
                  </li>
                  <li>
                    ne pas utiliser et/ou exploiter les coordonn&eacute;es &eacute;lectroniques et/ou postales des autres Utilisateurs du Site Internet et/ou de l&apos;Application
                    en vue de l&apos;envoi en masse de courrier &eacute;lectronique de sollicitation et de se livrer &agrave; une pratique de &laquo; spamming &raquo;.
                  </li>
                </ul>
                <p>
                  En cas de manquement &agrave; l&apos;une ou l&apos;autre de ces obligations et, sans que cette liste ne soit limitative, l&apos;Utilisateur reconna&icirc;t et
                  accepte que la Soci&eacute;t&eacute; aura la facult&eacute; de lui refuser, unilat&eacute;ralement et sans notification pr&eacute;alable, l&apos;acc&egrave;s
                  &agrave; tout ou partie du Site Internet et/ou de l&apos;Application.
                </p>
                <p>
                  <strong>5.2 GARANTIE DE LA SOCI&Eacute;T&Eacute;</strong>
                </p>
                <p>
                  La Soci&eacute;t&eacute; met &agrave; la disposition de l&apos;Utilisateur, au travers de son Site Internet et/ou de son Application, l&apos;acc&egrave;s &agrave;
                  un certain nombre de Services visant &agrave; l&apos;accompagner dans le cadre de son projet immobilier.
                </p>
                <p>L&apos;Utilisateur est parfaitement conscient que la Soci&eacute;t&eacute; ne peut notamment garantir les suites donn&eacute;es :</p>
                <ul>
                  <li>
                    aux r&eacute;ponses qui lui seront apport&eacute;es suite &agrave; ses demandes de mises en relation avec les Annonceurs ayant diffus&eacute; des annonces de
                    location et/ou de vente de biens immobiliers ;
                  </li>
                  <li>aux annonces de location et/ou de vente de biens immobiliers qu&apos;il aura souhait&eacute; consulter sur le Site Internet et/ou l&apos;Application ;</li>
                  <li>
                    aux offres de financement immobilier qui lui seront propos&eacute;es par les &eacute;tablissements de cr&eacute;dit ou courtier avec lesquels il sera
                    entr&eacute; en relation via le Site Internet et/ou l&apos;Application;
                  </li>
                  <li>et plus g&eacute;n&eacute;ralement aux besoins particuliers de l&apos;Utilisateur.</li>
                </ul>
                <p>
                  La Soci&eacute;t&eacute; ne peut pas plus garantir la qualit&eacute; des estimations approximatives de biens immobiliers qu&apos;il aura effectu&eacute;es via les
                  Services accessibles sur le Site internet et/ou l&apos;Application et en vue de la mise en vente de son/ses bien(s) immobilier(s).
                </p>
                <p>
                  La Soci&eacute;t&eacute; d&eacute;cline toute responsabilit&eacute; quant &agrave; la fiabilit&eacute; et/ou la pertinence des informations fournies par les
                  Annonceurs et/ou les &eacute;tablissements de cr&eacute;dits sur le Site Internet et/ou sur l&apos;Application &ndash; lesdites informations &eacute;tant mises en
                  lignes et diffus&eacute;es sous leur enti&egrave;re responsabilit&eacute;.
                </p>
                <p>
                  La Soci&eacute;t&eacute; fait ses meilleurs efforts afin de mettre en relation les Utilisateurs et les Annonceurs et les &eacute;tablissements de cr&eacute;dits
                  partenaires de la Soci&eacute;t&eacute; proposant leurs services via le Site Internet et/ou l&apos;Application.
                </p>
                <p>
                  La Soci&eacute;t&eacute; ne garantit pas la conclusion de relation contractuelle entre l&apos;Utilisateur et lesdits Annonceurs et/ou &eacute;tablissements de
                  cr&eacute;dits partenaires.
                </p>
                <p>
                  Les Utilisateurs reconnaissent que la Soci&eacute;t&eacute; n&apos;intervient &agrave; ce titre &agrave; aucun moment dans les &eacute;changes et transactions
                  entre les Utilisateurs et les Annonceurs et / ou les &eacute;tablissements de cr&eacute;dit ou courtiers partenaires de la Soci&eacute;t&eacute; et
                  n&apos;intervient pas en tant que m&eacute;diateur entre les Utilisateurs et les Annonceurs et / ou &eacute;tablissements de cr&eacute;dit ou courtiers
                  partenaires de la Soci&eacute;t&eacute;.
                </p>
                <p>
                  Par cons&eacute;quent, la responsabilit&eacute;, d&eacute;lictuelle ou contractuelle de la Soci&eacute;t&eacute; ne pourra en aucun cas &ecirc;tre engag&eacute;e
                  pour la conclusion, la non-conclusion, l&apos;ex&eacute;cution, la r&eacute;solution ou la m&eacute;diation de toute relation contractuelle entre les Utilisateurs
                  et les Annonceurs et / ou &eacute;tablissements de cr&eacute;dit ou courtiers partenaires de la Soci&eacute;t&eacute; ou pour les cons&eacute;quences, quelles que
                  soient leur nature, r&eacute;sultant d&apos;un litige entre ces derniers.
                </p>
                <p>
                  Enfin, n&apos;exer&ccedil;ant pas une activit&eacute; d&apos;&eacute;tablissement de cr&eacute;dit et limitant son intervention &agrave; la simple mise en
                  relation de l&apos;Utilisateur avec les Annonceurs et les &eacute;tablissements de cr&eacute;dits ou courtiers partenaires du Site Internet et/ou de
                  l&apos;Application, la Soci&eacute;t&eacute; ne peut &ecirc;tre tenue pour responsable de :
                </p>
                <ul>
                  <li>
                    la qualit&eacute; des conseils prodigu&eacute;s par les Annonceurs et/ou &eacute;tablissement de cr&eacute;dits &agrave; l&apos;Utilisateur une fois leur mise
                    en relation par l&apos;interm&eacute;diaire des Services ;
                  </li>
                  <li>
                    en cas de r&eacute;ponse positive ou n&eacute;gative, tacite ou expresse d&apos;un &eacute;tablissement de cr&eacute;dit ou courtier partenaire &agrave; la
                    demande de financement de l&apos;Utilisateur ;
                  </li>
                  <li>
                    de la bonne ex&eacute;cution du pr&ecirc;t immobilier conclu entre un &eacute;tablissement de cr&eacute;dit ou courtier partenaire et l&apos;Utilisateur ;
                  </li>
                  <li>de la lic&eacute;it&eacute; absolue des solutions de financement propos&eacute;es par un &eacute;tablissement de cr&eacute;dit partenaire ;</li>
                  <li>
                    du non-respect par l&apos;&eacute;tablissement de cr&eacute;dit des choix de l&apos;Utilisateur quant &agrave; l&apos;utilisation de ses donn&eacute;es
                    personnelles.
                  </li>
                </ul>
                <p>
                  <strong>5.3 LIMITATION DE RESPONSABILITE</strong>
                </p>
                <p>
                  L&apos;Utilisateur est seul responsable de l&apos;utilisation qu&apos;il fait du Site Internet et/ou de l&apos;Application et des Services auxquels il
                  acc&egrave;de depuis le Site Internet et/ou l&apos;Application.
                </p>
                <p>
                  La Soci&eacute;t&eacute; ne pourra en aucun cas &ecirc;tre tenue responsable dans le cadre d&apos;une proc&eacute;dure introduite &agrave; l&apos;encontre de
                  l&apos;Utilisateur qui se serait rendu coupable d&apos;une utilisation non-conforme du Site Internet et/ou de l&apos;Application et/ou des Services qu&apos;il
                  procure.
                </p>
                <p>
                  L&apos;Utilisateur reconna&icirc;t et accepte &agrave; cet &eacute;gard qu&apos;il fera son affaire personnelle de toute r&eacute;clamation ou proc&eacute;dure
                  form&eacute;e contre la Soci&eacute;t&eacute;, du fait de l&apos;utilisation non-conforme par lui des Services et/ou du Site Internet et/ou de l&apos;Application.
                </p>
                <p>Le Site Internet et/ou l&apos;Application peut contenir des liens hypertextes renvoyant vers des sites Internet de tiers.</p>
                <p>
                  A cet &eacute;gard, compte tenu du caract&egrave;re &eacute;vanescent du contenu qui peut y &ecirc;tre diffus&eacute;, la responsabilit&eacute; de la
                  Soci&eacute;t&eacute; ne saurait &ecirc;tre engag&eacute;e dans le cas o&ugrave; le contenu desdits sites Internet de tiers contreviendrait aux dispositions
                  l&eacute;gales et/ou r&eacute;glementaires en vigueur.
                </p>
                <p>En toute hypoth&egrave;se, la Soci&eacute;t&eacute; ne saurait &ecirc;tre responsable :</p>
                <ul>
                  <li>
                    en cas d&apos;indisponibilit&eacute; des Services pour des raisons telles que la d&eacute;faillance du r&eacute;seau public d&apos;&eacute;lectricit&eacute;, la
                    d&eacute;faillance des r&eacute;seaux c&acirc;bl&eacute;s de t&eacute;l&eacute;communications, la perte de connectivit&eacute; au r&eacute;seau Internet due aux
                    op&eacute;rateurs publics ou priv&eacute;s, notamment de l&apos;Utilisateur, dont les causes proviennent notamment de gr&egrave;ves, de temp&ecirc;tes, de
                    tremblements de terre ou de toute autre cause ayant les caract&eacute;ristiques de la force majeure ;
                  </li>
                  <li>en cas d&apos;utilisation des Services par un Utilisateur dans des conditions non-conformes aux termes des pr&eacute;sentes CGU;</li>
                  <li>
                    dans les limites de la l&eacute;gislation en vigueur, pour tout dommage indirect et ce y compris notamment les pertes de profit, de donn&eacute;es ou tout autre
                    perte de biens incorporels, et ce m&ecirc;me si la Soci&eacute;t&eacute; a &eacute;t&eacute; inform&eacute; de la potentialit&eacute; de tels dommages, pouvant
                    survenir (i) de l&apos;utilisation ou de l&apos;impossibilit&eacute; d&apos;utiliser les Services (ii) suite &agrave; l&apos;acc&egrave;s auxdits Services par
                    un Utilisateur non autoris&eacute;.
                  </li>
                </ul>
                <p>
                  La Soci&eacute;t&eacute; ne saurait &ecirc;tre tenue responsable de tout dysfonctionnement de quelque nature qu&apos;il soit relatif au mat&eacute;riel
                  informatique de l&apos;Utilisateur ainsi qu&apos;&agrave; sa connexion d&apos;acc&egrave;s &agrave; Internet, lors de l&apos;acc&egrave;s au Site Internet et/ou
                  &agrave; l&apos;Application et plus g&eacute;n&eacute;ralement aux Services.
                </p>
                <p>Plus particuli&egrave;rement, la Soci&eacute;t&eacute; ne saurait garantir l&apos;Utilisateur des Services sur :</p>
                <ul>
                  <li>
                    les probl&egrave;mes de vitesses d&apos;acc&egrave;s aux Sites Internet et/ou aux Applications et/ou de vitesse de mise en m&eacute;moire tampon de
                    l&apos;ordinateur de l&apos;Utilisateur des vid&eacute;os accessibles via les Services que l&apos;Utilisateur serait susceptible de rencontrer.
                  </li>
                  <li>
                    la qualit&eacute; des textes, informations, descriptifs, photographies et Vid&eacute;ogrammes adjoints aux annonces de location et/ou de vente de biens
                    immobiliers publi&eacute;es par l&apos;Utilisateur.
                  </li>
                </ul>
                <p>
                  <strong>CONTENU ILLICITE</strong>
                </p>
                <p>
                  En sa qualit&eacute; de prestataire d&apos;h&eacute;bergement au sens des dispositions de l&apos;article 6-I-7 de la Loi n&deg;2004-575 du 21 juin 2004 des
                  annonces diffus&eacute;es sous la responsabilit&eacute; exclusive des Annonceurs, la Soci&eacute;t&eacute; ne peut mat&eacute;riellement pas organiser une
                  surveillance g&eacute;n&eacute;rale des annonces qu&apos;elle h&eacute;berge sur le Site Internet et/ou l&apos;Application et ne peut en d&eacute;terminer le
                  caract&egrave;re licite ou non.
                </p>
                <p>
                  Au cas o&ugrave; l&apos;Utilisateur est amen&eacute; &agrave; d&eacute;couvrir que tout ou partie d&apos;une annonce &ndash; mise en ligne sur Site Internet et/ou
                  l&apos;Application par un Annonceur &ndash; pourrait rev&ecirc;tir un caract&egrave;re manifestement illicite, l&apos;Utilisateur est invit&eacute; &agrave; le
                  signaler &agrave; la Soci&eacute;t&eacute;.
                </p>
                <p>
                  Conform&eacute;ment aux dispositions de l&apos;article 6-I-5 de la Loi n&deg;2004-575 du 21 juin 2004, l&apos;Utilisateur pourra &ecirc;tre invit&eacute; par la
                  Soci&eacute;t&eacute; &agrave; pr&eacute;ciser sa demande en lui communiquant par &eacute;crit l&apos;ensemble des mentions suivantes :
                </p>
                <ul>
                  <li>les noms, pr&eacute;noms, date, lieu de naissance, adresse postale ;</li>
                  <li>la date de signalement de l&apos;annonce litigieuse ;</li>
                  <li>le num&eacute;ro de(s) l&apos;annonce(s) litigeuse(s) ;</li>
                  <li>la/les adresse(s) URL de(s) l&apos;annonce(s) litigeuse(s) ;</li>
                  <li>
                    les motifs pour lesquels l&apos;annonce doit &ecirc;tre retir&eacute;e, comprenant la mention des dispositions l&eacute;gales et des justifications de faits ;
                  </li>
                  <li>
                    la copie de la correspondance adress&eacute;e &agrave; l&apos;annonceur demandant le retrait ou la modification de l&apos;annonce ou la justification de ce que
                    l&apos;annonceur n&apos;a pu &ecirc;tre contact&eacute;.
                  </li>
                </ul>
                <p>
                  A cet &eacute;gard, l&apos;Utilisateur s&apos;engage &agrave; ne pas abuser de cette facult&eacute;, &agrave; d&eacute;faut de quoi, il reconna&icirc;t et accepte
                  qu&apos;il s&apos;expose &agrave; des poursuites p&eacute;nales, par application des dispositions de l&apos;article 6.I.4 de la Loi n&deg;2004-575 du 21 juin 2004
                  selon lequel : &laquo; Le fait, pour toute personne, de pr&eacute;senter aux personnes mentionn&eacute;es au 2 (h&eacute;bergeurs) un contenu ou une
                  activit&eacute; comme &eacute;tant illicite dans le but d&apos;en obtenir le retrait ou d&apos;en faire cesser la diffusion, alors qu&apos;elle sait cette
                  information inexacte, est puni d&apos;une peine d&apos;un an d&apos;emprisonnement et de 15 000 EUR d&apos;amende &raquo;.
                </p>
                <p>
                  <strong>5.4 FORCE MAJEURE</strong>
                </p>
                <p>
                  La responsabilit&eacute; de la Soci&eacute;t&eacute; ne pourra pas &ecirc;tre recherch&eacute;e si l&apos;ex&eacute;cution de l&apos;une de ses obligations est
                  emp&ecirc;ch&eacute;e ou retard&eacute;e en raison d&apos;un cas de force majeure tel que d&eacute;fini par l&apos;article 1218 du Code civil tel que
                  modifi&eacute; par l&apos;ordonnance n&deg; 2016-131 du 10 f&eacute;vrier 2016 et interpr&eacute;t&eacute; par la jurisprudence des Tribunaux fran&ccedil;ais, et
                  notamment, sans s&apos;y limiter, les catastrophes naturelles, incendies, dysfonctionnement ou interruption du r&eacute;seau de t&eacute;l&eacute;communications
                  ou du r&eacute;seau &eacute;lectrique.
                </p>
                <h2>6. RECLAMATION &ndash; ASSISTANCE TECHNIQUE</h2>
                <p>
                  Pour toute information de nature technique ou relative au fonctionnement des Services accessibles via le Site internet et/ou l&apos;Application,
                  l&apos;Utilisateur est invit&eacute; &agrave; se reporter &agrave; la rubrique &laquo; Contact &raquo; accessible sur le Site Internet et/ou l&apos;Application
                  et/ou &agrave; adresser sa r&eacute;clamation aux coordonn&eacute;es vis&eacute;es &agrave; l&apos;article 1.3 des pr&eacute;sentes CGU.
                </p>
                <h2>7. PROPRI&Eacute;T&Eacute; INTELLECTUELLE</h2>
                <p>
                  <strong>7.1 DROIT D&apos;AUTEUR SUR LE SITE INTERNET ET/OU L&apos;APPLICATION DE LA SOCI&Eacute;T&Eacute;</strong>
                </p>
                <p>
                  La Soci&eacute;t&eacute; est le titulaire ou le concessionnaire des droits de propri&eacute;t&eacute; intellectuelle tant de la structure g&eacute;n&eacute;rale
                  du Site Internet et/ou de l&apos;Application que de son contenu (textes, slogans, graphiques, images, vid&eacute;os, photos et autres contenus).
                </p>
                <p>
                  D&egrave;s lors, conform&eacute;ment aux dispositions du Livre 1er du Code de la propri&eacute;t&eacute; intellectuelle, toute repr&eacute;sentation,
                  reproduction, modification, d&eacute;naturation et/ou exploitation totale ou partielle du Site Internet, et/ou de l&apos;Application et/ou de leur contenu et/ou
                  des Services, par quelque proc&eacute;d&eacute; que ce soit et sur quelque support que ce soit, sans l&apos;autorisation expresse et pr&eacute;alable de la
                  Soci&eacute;t&eacute;, est prohib&eacute;e et constitue des actes de contrefa&ccedil;on de droits d&apos;auteur.
                </p>
                <p>
                  De m&ecirc;me, toute exploitation non autoris&eacute;e du Site Internet, et/ou de l&apos;Application et/ou de son contenu et/ou des Services engage la
                  responsabilit&eacute; p&eacute;nale et civile de l&apos;Utilisateur sur le fondement de la contrefa&ccedil;on de droits d&apos;auteur.
                </p>
                <p>
                  La Soci&eacute;t&eacute; entend divulguer le Site Internet et/ou l&apos;Application et les Services qu&apos;afin d&apos;en permettre un acc&egrave;s sur le
                  r&eacute;seau Internet, et ce :
                </p>
                <li>
                  depuis un ordinateur ou un terminal &eacute;quivalant disposant d&apos;un acc&egrave;s &agrave; un ou plusieurs r&eacute;seaux de t&eacute;l&eacute;communications
                  permettant l&apos;acc&egrave;s au r&eacute;seau Internet et d&apos;un logiciel de navigation sur le r&eacute;seau Internet (de type Internet Explorer, Mozilla
                  Firefox, etc.) ;
                </li>
                <li>
                  un terminal mobile disposant d&apos;un acc&egrave;s &agrave; un r&eacute;seau de t&eacute;l&eacute;communications permettant l&apos;acc&egrave;s au r&eacute;seau
                  Internet (connexion Wifi, 3/4G, Edge, etc.) ;
                </li>
                <p>
                  Toute autre utilisation du Site Internet et/ou de l&apos;Application et/ou des Services est r&eacute;put&eacute;e de plein droit r&eacute;serv&eacute;e &agrave;
                  la Soci&eacute;t&eacute; et constituer une atteinte &agrave; son droit de divulgation sur le Site Internet et/ou sur l&apos;Application et/ou les Services.
                </p>
                <p>
                  <strong>7.2 SIGNES DISTINCTIFS</strong>
                </p>
                <p>
                  Les marques, logos, d&eacute;nominations sociales, sigles, noms commerciaux, enseignes et/ou nom de domaine de la Soci&eacute;t&eacute; et/ou de ses partenaires
                  commerciaux mentionn&eacute;s sur le Site Internet et/ou sur l&apos;Application, permettant l&apos;acc&egrave;s aux Services mis &agrave; disposition par la
                  Soci&eacute;t&eacute;, constituent des signes distinctifs insusceptibles d&apos;utilisation sans l&apos;autorisation expresse et pr&eacute;alable de leur
                  titulaire.
                </p>
                <p>
                  Toute repr&eacute;sentation et/ou reproduction et/ou exploitation partielle ou totale de ces signes distinctifs est donc prohib&eacute;e et constitutif de
                  contrefa&ccedil;on de marque, en application des dispositions du Livre 7 du Code de la propri&eacute;t&eacute; intellectuelle, d&apos;usurpation de
                  d&eacute;nomination sociale, nom commercial et de nom de domaine engageant la responsabilit&eacute; civile d&eacute;lictuelle de son auteur.
                </p>
                <p>
                  <strong>7.3 BASES DE DONN&Eacute;ES</strong>
                </p>
                <p>
                  L&apos;Utilisateur reconna&icirc;t irr&eacute;vocablement que le Site Internet, et/ou l&apos;Application et les Services sont constitu&eacute;s d&apos;une ou
                  plusieurs bases de donn&eacute;es mis &agrave; disposition par la Soci&eacute;t&eacute; en qualit&eacute; de producteur desdites bases de donn&eacute;es au sens
                  des dispositions des articles L.341-1 et suivants du Code de la propri&eacute;t&eacute; intellectuelle.
                </p>
                <p>
                  D&egrave;s lors, conform&eacute;ment aux dispositions de l&apos;article L. 342-1 du m&ecirc;me Code, l&apos;Utilisateur s&apos;interdit de proc&eacute;der
                  &agrave; :
                </p>
                <ul>
                  <li>
                    l&apos;extraction par transfert permanent ou temporaire de la totalit&eacute; ou d&apos;une partie qualitativement ou quantitativement substantielle du contenu
                    d&apos;une ou plusieurs des bases des donn&eacute;es accessibles sur le Site Internet et/ou l&apos;Application et/ou les Services sur un autre support, par tout
                    moyen et sous toute forme que ce soit, en ce compris &agrave; des fins d&apos;utilisation ou de consultation par un m&eacute;dia et/ou un
                    proc&eacute;d&eacute;(s) non autoris&eacute;(s) par la Soci&eacute;t&eacute; ;
                  </li>
                  <li>
                    la r&eacute;utilisation, par la mise &agrave; la disposition du public de la totalit&eacute; ou d&apos;une partie qualitativement ou quantitativement
                    substantielle du contenu d&apos;une ou plusieurs des bases des donn&eacute;es accessibles sur le Site Internet et/ou l&apos;Application et/ou les Services,
                    quelle qu&apos;en soit la forme, y compris par un lien hypertexte, un m&eacute;dia et/ou un proc&eacute;d&eacute;(s) non autoris&eacute;(s) par la
                    Soci&eacute;t&eacute; ;
                  </li>
                  <li>
                    la constitution, l&apos;&eacute;dition, la maintenance, la mise &agrave; jour, l&apos;importation, l&apos;exportation, la mise &agrave; disposition de tiers,
                    &agrave; titre gracieux ou on&eacute;reux, et la participation aux actes pr&eacute;cit&eacute;s, d&apos;une base de donn&eacute;es concurrente issue de tout ou
                    partie d&apos;une ou plusieurs des bases de donn&eacute;es de la Soci&eacute;t&eacute; ;
                  </li>
                  <li>
                    la visualisation sur un &eacute;cran par un autre proc&eacute;d&eacute; ou m&eacute;dia que ceux par lesquels la Soci&eacute;t&eacute; entend divulguer le Site
                    Internet et/ou l&apos;Application et les Services;
                  </li>
                  <li>
                    d&apos;une mani&egrave;re g&eacute;n&eacute;rale, toute extraction, utilisation, stockage, reproduction, repr&eacute;sentation ou conservation, directe ou
                    indirecte, partielle ou totale, y compris en m&eacute;moire tampon ou temporaire, qualitativement ou quantitativement substantielle du contenu d&apos;une ou
                    plusieurs des bases de donn&eacute;es de la Soci&eacute;t&eacute;, commise par l&apos;un des proc&eacute;d&eacute;s vis&eacute;s ci-dessus est strictement
                    prohib&eacute;e, y compris par un m&eacute;dia non autoris&eacute; par la Soci&eacute;t&eacute;.
                  </li>
                </ul>
                <p>
                  <strong>7.4 CONTENU DES SERVICES</strong>
                </p>
                <p>
                  L&apos;Utilisateur reconna&icirc;t et accepte que l&apos;acc&egrave;s au Site Internet et/ou &agrave; l&apos;Application et aux Services mis &agrave; sa
                  disposition par la Soci&eacute;t&eacute; ne saurait emporter une quelconque cession ou concession des droits de propri&eacute;t&eacute; intellectuelle (droits
                  d&apos;auteurs notamment) et autres droits au b&eacute;n&eacute;fice de l&apos;Utilisateur.
                </p>
                <p>
                  L&apos;acc&egrave;s aux Services est exclusivement limit&eacute; &agrave; l&apos;usage priv&eacute; et personnel de l&apos;Utilisateur dans les conditions et
                  limites d&eacute;finies dans les pr&eacute;sentes CGU et conform&eacute;ment aux dispositions de l&apos;article L.122-5 2&deg; du Code de la
                  propri&eacute;t&eacute; Intellectuelle.
                </p>
                <p>
                  Ainsi, l&apos;Utilisateur reconna&icirc;t et accepte que l&apos;usage priv&eacute; et personnel qui lui est conc&eacute;d&eacute; par la Soci&eacute;t&eacute;, au
                  titre de l&apos;acc&egrave;s &agrave; ses Services, exclue notamment l&apos;acc&egrave;s aux Services en vue d&apos;une utilisation collective de son contenu, la
                  reproduction, la repr&eacute;sentation, la revente, l&apos;&eacute;change, la location, le transfert &agrave; un tiers, la modification, l&apos;adaptation, la
                  correction, et ce tant &agrave; titre gracieux qu&apos;on&eacute;reux, de tout ou partie du Site Internet et/ou de l&apos;Application, des Services, et de leurs
                  contenus.
                </p>
                <p>
                  <strong>7.5 LIENS HYPERTEXTES</strong>
                </p>
                <p>
                  Les liens hypertextes accessibles sur le Site Internet et/ou sur l&apos;Application, permettant l&apos;acc&egrave;s aux Services, en direction d&apos;autres sites
                  Internet et/ou applications et d&apos;une mani&egrave;re g&eacute;n&eacute;rale vers toutes ressources existantes sur Internet ne sauraient engager la
                  responsabilit&eacute; de la Soci&eacute;t&eacute;.
                </p>
                <p>
                  L&apos;Utilisateur ne pourra en aucun cas mettre en place de liens hypertextes &agrave; destination de pages profondes des Sites Internet, permettant
                  l&apos;acc&egrave;s aux Services et ce, par quelconque proc&eacute;d&eacute; technique destin&eacute; &agrave; passer outre le champ d&apos;identification de
                  l&apos;Utilisateur ou &agrave; proc&eacute;der &agrave; l&apos;aspiration de tout ou partie du contenu des Services mis &agrave; disposition par la
                  Soci&eacute;t&eacute;. La technique du &apos;framing&apos; est interdite, sauf autorisation expresse et pr&eacute;alable de la Soci&eacute;t&eacute;
                </p>
                <h2>8. DISPOSITIONS DIVERSES</h2>
                <p>
                  <strong>8.1 CORRESPONDANCE &ndash; PREUVE</strong>
                </p>
                <p>
                  Sauf disposition particuli&egrave;re des pr&eacute;sentes CGU, les correspondances &eacute;chang&eacute;es entre la Soci&eacute;t&eacute; et l&apos;Utilisateur
                  sont exclusivement assur&eacute;es par courrier &eacute;lectronique. L&apos;Utilisateur reconna&icirc;t et accepte que les informations d&eacute;livr&eacute;es
                  par la Soci&eacute;t&eacute; par courrier &eacute;lectronique et sur son Site Internet et/ou son Application font foi entre lui et la Soci&eacute;t&eacute;. Les
                  &eacute;l&eacute;ments tels que le moment de la r&eacute;ception ou de l&apos;&eacute;mission, ainsi que la qualit&eacute; des donn&eacute;es re&ccedil;ues feront
                  foi par priorit&eacute; telles que figurant sur le Site Internet et/ou sur l&apos;Application de la Soci&eacute;t&eacute;, ou telles qu&apos;authentifi&eacute;es
                  par les proc&eacute;dures informatis&eacute;es de la Soci&eacute;t&eacute;, sauf &agrave; en apporter la preuve &eacute;crite et contraire par l&apos;Utilisateur.
                  La port&eacute;e de la preuve des informations d&eacute;livr&eacute;es par le Site Internet et/ou l&apos;Application de la Soci&eacute;t&eacute; est celle
                  accord&eacute;e &agrave; un original au sens d&apos;un document &eacute;crit papier, sign&eacute; de mani&egrave;re manuscrite.
                </p>
                <p>
                  <strong>8.2 INT&Eacute;GRALIT&Eacute; DES CGU</strong>
                </p>
                <p>
                  Les pr&eacute;sentes CGU expriment l&apos;int&eacute;gralit&eacute; des obligations de la Soci&eacute;t&eacute; et de l&apos;Utilisateur. Le fait pour l&apos;une
                  des parties de ne pas se pr&eacute;valoir d&apos;un manquement par l&apos;autre partie, &agrave; l&apos;une quelconque des obligations vis&eacute;es dans les
                  pr&eacute;sentes, ne saurait &ecirc;tre interpr&eacute;t&eacute; pour l&apos;avenir comme une renonciation &agrave; l&apos;obligation en cause.
                </p>
                <p>
                  <strong>8.3 NON VALIDITE PARTIELLE</strong>
                </p>
                <p>
                  Dans l&apos;hypoth&egrave;se o&ugrave; une ou plusieurs stipulations des pr&eacute;sentes CGU seraient consid&eacute;r&eacute;es comme nulles,
                  r&eacute;put&eacute;es non &eacute;crites ou d&eacute;clar&eacute;es comme telles en application d&apos;une loi, d&apos;un r&egrave;glement ou &agrave; la suite
                  d&apos;une d&eacute;cision d&apos;une juridiction comp&eacute;tente ayant autorit&eacute; de la chose jug&eacute;e en dernier ressort, les autres stipulations
                  garderont toute leur force et leur port&eacute;e et resteront pleinement applicable, sauf si la ou les stipulations non valides pr&eacute;sentaient un
                  caract&egrave;re substantiel et que leur disparition remettait en cause l&apos;&eacute;quilibre contractuel.
                </p>
                <p>
                  <strong>8.4 TITRES</strong>
                </p>
                <p>
                  En cas de difficult&eacute;s d&apos;interpr&eacute;tation entre l&apos;un des titres figurant en t&ecirc;te des clauses des pr&eacute;sentes CGU, et l&apos;une
                  des clauses, les titres seront d&eacute;clar&eacute;s inexistants.
                </p>
                <h2>9. DROIT APPLICABLE ET REGLEMENT DES LITIGES</h2>
                <p>
                  Les pr&eacute;sentes CGU sont soumises au droit fran&ccedil;ais. En cas de litige relatif &agrave; l&apos;application, l&apos;interpr&eacute;tation, la
                  validit&eacute; et l&apos;ex&eacute;cution des pr&eacute;sentes CGU, et &agrave; d&eacute;faut d&apos;accord amiable entre les parties, comp&eacute;tence expresse
                  est donn&eacute;e aux tribunaux fran&ccedil;ais.
                </p>
                <h2>10. PROTECTION DES DONNEES A CARACTERE PERSONNEL</h2>
                <p>
                  Conform&eacute;ment &agrave; la R&eacute;glementation relative &agrave; la protection des donn&eacute;es &agrave; caract&egrave;re personnel, l&apos;Utilisateur
                  est inform&eacute; que la Soci&eacute;t&eacute;, en sa qualit&eacute; de responsable de traitement, met en &oelig;uvre un traitement de donn&eacute;es &agrave;
                  caract&egrave;re personnel dans le cadre de l&rsquo;utilisation du Site Internet.
                </p>
                <p>
                  Pour toute information concernant le traitement des donn&eacute;es &agrave; caract&egrave;re personnel et conna&icirc;tre l&rsquo;&eacute;tendue de leurs droits,
                  les Utilisateurs peuvent consulter la Politique de protection des donn&eacute;es personnelles, disponible via ce{' '}
                  <a href="https://www.seloger.com/CGU_politique_de_confidentialite.html">lien</a>.
                </p>
                <h2>11. COOKIES</h2>
                <p>
                  Lors de la consultation du Site Internet et/ou de l&apos;Application, des informations sont susceptibles d&apos;&ecirc;tre enregistr&eacute;es dans des fichiers
                  &laquo; cookies &raquo; install&eacute;s dans l&apos;ordinateur, tablette ou t&eacute;l&eacute;phone mobile de l&apos;Utilisateur. Pour conna&icirc;tre notre
                  politique des cookies, les Utilisateurs peuvent consulter la Politique de cookies, disponible via ce{' '}
                  <a href="https://www.seloger.com/CGU_politique_de_confidentialite.html">lien</a>.
                </p>
                <h2>12. NEWSLETTER ET ALERTES</h2>
                <p>
                  Afin de tenir inform&eacute; l&apos;Utilisateur de l&apos;actualit&eacute; de la Soci&eacute;t&eacute; et des avantages dont il pourrait b&eacute;n&eacute;ficier,
                  celui-ci peut recevoir des informations commerciales de la Soci&eacute;t&eacute; par communication &eacute;lectronique (email, sms&hellip;). Si l&apos;Utilisateur
                  ne souhaite pas recevoir d&apos;offres et informations de la Soci&eacute;t&eacute;, il peut s&apos;opposer aux envois en le pr&eacute;cisant, &agrave; tout
                  moment, dans son compte rubrique &apos;Abonnements&apos; et en cliquant sur le lien hypertexte de d&eacute;sabonnement qui se trouve en bas de chaque
                  communication &eacute;lectronique re&ccedil;ue.
                </p>
                <p>
                  L&apos;Utilisateur peut personnaliser l&apos;envoi des newsletters et g&eacute;rer les abonnements aux alertes qu&apos;il souhaite recevoir lors de la
                  cr&eacute;ation de son compte ou en se rendant dans son compte rubrique &apos;Abonnements&apos;. L&apos;Utilisateur a alors la possibilit&eacute; de
                  s&eacute;lectionner parmi les diff&eacute;rentes cat&eacute;gories de newsletters et alertes celles qui l&apos;int&eacute;ressent. L&apos;Utilisateur peut faire
                  cesser &agrave; tout moment l&apos;envoi des newsletters et alertes en se rendant dans son compte.
                </p>
                <p>
                  A d&eacute;faut de s&eacute;lection et si celui-ci ne s&apos;est pas oppos&eacute; lors de la cr&eacute;ation de son compte, l&apos;Utilisateur sera susceptible
                  de recevoir des informations sur l&apos;actualit&eacute; la Soci&eacute;t&eacute; et des newsletters et alertes qui portent sur des produits et services analogues
                  &agrave; ceux que l&apos;Utilisateur a d&eacute;j&agrave; consult&eacute;s sur le Site Internet et/ou l&apos;Application.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default CGU
